interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btnBase} border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={`${btnBase} ${
              p === current
                ? "border-primary-500 bg-primary-500 font-medium text-background-50 dark:text-foreground-950"
                : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="px-1 text-foreground-400">
            ...
          </span>
        )
      )}
      <button
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${btnBase} border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}